import Menu from 'side-panel-menu-thing'
import BigPicture from 'bigpicture'
import StLogo from '../components/st-logo.svelte'
import NewsletterBlock from '../components/newsletter-block.svelte'
import lozad from 'lozad'
import loadjs from 'loadjs'
import { get } from 'money-clip'

const { $ } = window
const $body = $(document.body)

export default {
	init() {
		let $stLogo = $('#st_logo')

		if ($stLogo.length) {
			get('logoCoords', {
				maxAge: 5000,
			}).then((coords) => {
				new StLogo({
					target: $stLogo[0],
					props: {
						coords: coords ? coords : false,
						shoudCacheCoords: true,
					},
				})
			})
		}

		// init off canvas nav
		const menu = new Menu({
			target: document.body,
			props: {
				target: document.body,
				content: document.getElementById('menu'),
				fixed: true,
				width: 320,
			},
		})
		$body.on('click', '#toggle_nav', menu.show)
	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
		let $lozad = $('.lozad')

		setUpBlocks()

		$(document).on(
			'click',
			'.menu-section .menu-item-has-children > a',
			function (e) {
				let $el = $(this)
				e.preventDefault()
				$el.parent().toggleClass('show-subnav')
			}
		)

		// class to hide outlines if not using keyboard
		$body.on('mousedown', function () {
			$body.addClass('using-mouse')
		})
		$body.on('keydown', function () {
			$body.removeClass('using-mouse')
		})

		// lazyload
		if ($lozad.length) {
			let observer = lozad()
			observer.observe()
		}

		let $blocksGallery = $('.wp-block-gallery .wp-block-image  > a')
		if ($blocksGallery.length) {
			let $caption = $('.blocks-gallery-item__caption')
			if ($caption) {
				$caption.each(function () {
					$(this).siblings('a')[0].setAttribute('data-caption', $(this).text())
				})
			}

			$blocksGallery.each(function (index, el) {
				el.setAttribute('data-bp', el.href)
			})

			$blocksGallery.on('click', function (e) {
				e.preventDefault()
				BigPicture({
					el: this,
					gallery: '.wp-block-gallery',
					loop: true,
					noLoader: true,
				})
			})
		}

		// let $wpBlockImg = $('.wp-block-image')
		// if ($wpBlockImg.length) {
		// 	$wpBlockImg.on('click', function (e) {
		// 		const $this = $(this)
		// 		const $imgEls = $this.find('img')
		// 		e.preventDefault()
		// 		BigPicture({
		// 			el: $imgEls.length ? $imgEls[0] : this,
		// 			imgSrc: this.href,
		// 		})
		// 	})
		// }

		let $wpMediaTxtBlockImg = $('.wp-block-media-text__media')
		if ($wpMediaTxtBlockImg.length) {
			$wpMediaTxtBlockImg.on('click', function (e) {
				const $this = $(this)
				const $imgEls = $this.find('img')
				e.preventDefault()
				BigPicture({
					el: $imgEls.length ? $imgEls[0] : this,
					imgSrc: this.href,
				})
			})
		}
	},
}

function setUpBlocks() {
	// const $document = $(document)
	const $youtubeGrid = $('.youtube-grid')
	const $testimonialGrid = $('.block-testimonial-grid')
	const $newsletterSignup = $('#newsletter_block')

	// youtube grid
	if ($youtubeGrid.length) {
		// grid
		loadMacy(() => {
			window.Macy({
				container: '.youtube-grid',
				useContainerForBreakpoints: true,
				columns: 3,
				margin: 15,
				breakAt: {
					800: {
						columns: 2,
					},
					500: {
						columns: 1,
						margin: {
							y: 20,
						},
					},
					200: {
						margin: {
							y: 14,
						},
					},
				},
			})
		})
		// bigpicture
		$youtubeGrid.find('a').on('click', function (e) {
			let ytSrc = this.getAttribute('data-ytsrc')
			if (ytSrc) {
				e.preventDefault()
				BigPicture({
					el: this,
					ytSrc,
				})
			}
		})
	}

	// testimonial grid
	if ($testimonialGrid.length) {
		let $testimonials = $('.testimonial-box > a')
		let testimonialsLength = $testimonials.length
		// grid
		loadMacy(() => {
			window.Macy({
				container: '.block-testimonial-grid',
				columns: testimonialsLength > 2 ? 3 : testimonialsLength > 1 ? 2 : 1,
				margin: 15,
				useContainerForBreakpoints: true,
				breakAt: {
					1100: {
						columns: testimonialsLength > 1 ? 2 : 1,
					},
					700: {
						columns: 1,
						margin: {
							y: 20,
						},
					},
					350: {
						margin: {
							y: 14,
						},
					},
				},
			})
		})
		// bigpicture
		$testimonials.on('click', function (e) {
			let $this = $(this)
			let ytSrc = $this.data('youtubeId')
			if (!ytSrc) {
				return
			}
			e.preventDefault()
			BigPicture({
				el: this,
				ytSrc,
			})
		})
	}

	if ($newsletterSignup.length) {
		new NewsletterBlock({
			target: $newsletterSignup[0],
			props: $newsletterSignup.data(),
		})
	}
}

function loadMacy(cb) {
	if (window.Macy) {
		cb()
		return
	}
	loadjs('https://cdn.jsdelivr.net/npm/macy@2.5.1/dist/macy.min.js', cb)
}
